import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

import LayoutScreen from '@/components/common/LayoutScreen';
import { getToken, redirectIfValidToken } from '@/utils/helpers/auth';

import LoginForm from '../../../components/pages/login/LoginForm';

const LoginPage = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { t } = useTranslation();
  const router = useRouter();

  useEffect(() => {
    const token = getToken();

    if (token) {
      redirectIfValidToken(token, router, {
        cb: () => setIsInitialized(true),
        disableCallbackIfValidToken: true,
      });
    } else setIsInitialized(true);
  }, [router]);

  return (
    <LayoutScreen title={t('login:title')} isLoading={!isInitialized}>
      <LoginForm />
    </LayoutScreen>
  );
};

export default LoginPage;
